import $ from "jquery";
import ProgressBar from "./ProgressBar";
let WebV2MovieDetails = require('../web/v2/movie_details');
export default class ContentTile {

    constructor(object, additional_classes=[]) {
        this.object = object;
        this.additional_classes = additional_classes;
    }

    element(include_progress=false, dismissable=false) {
        let object_link = document.createElement("a");
        object_link.href = 'javascript: void(0);';
        object_link.tabIndex = '0';
        object_link.style.width = '100%';
        object_link.style.display = 'inline-block';
        object_link.dataset['id'] = this.object['id'];
        object_link.dataset['kind'] = this.object['kind'];

        for (let i in this.additional_classes) {
            object_link.classList.add(this.additional_classes[i]);
        }

        let tile = document.createElement("div");
        tile.classList.add('tile');
        tile.classList.add('tile-data');
        tile.classList.add('border');
        tile.classList.add('overflow-hidden');
        tile.classList.add('tile-item-movie-' + this.object['id']);
        tile.classList.add('overflow-hidden');

        let tile_media = document.createElement("div");
        tile_media.classList.add('tile__media');
        tile_media.classList.add('horizContainer');

        let cover_art_img = document.createElement("img");
        cover_art_img.classList.add('tile__img');

        cover_art_img.src = this.resolveCoverArtSrc();
        cover_art_img.alt = '';

        $(cover_art_img).bind('load', function (e) {
            let $loaded = $(this).parent().parent().find('.tile__title');
            if ($loaded) {
                $loaded.css('opacity', '0')
            }
        });

        tile_media.appendChild(cover_art_img);
        tile.appendChild(tile_media);

        let tile_details = document.createElement("div");
        tile_details.classList.add('tile__details');

        let tile_title = document.createElement("div");
        tile_title.classList.add('tile__title');
        tile_title.innerText = this.resolveName();
        tile_details.appendChild(tile_title);
        tile.appendChild(tile_details);

        if ( include_progress ) {
            let resume_time = this.object['resume_time'] ? this.object['resume_time'] : 5;
            let progress = new ProgressBar( this.object['duration'],  resume_time);
            let progress_bar = progress.element();
            if ( progress_bar ) {
                let tile_progress = document.createElement("div");
                tile_progress.classList.add('tile__details__progress');
                tile_progress.appendChild( progress_bar );
                tile.appendChild(tile_progress);
            }
        }

        object_link.addEventListener("click", (e) => {
            WebV2MovieDetails.displayModal();
            WebV2MovieDetails.initModalMovieDetails(object_link);
        });

        object_link.classList.add('bound');

        if (!dismissable) {
            // Default path: tile first, then optional ranking explain (search /
            // suggestions). Keep this order so non-CW callers are unchanged.
            object_link.appendChild(tile);
            // Super-admin ranking diagnostics. Only present when the API attached
            // `ranking_explain`, which it does solely for a super admin that asked.
            let explain = this.object['ranking_explain'];
            if (explain) {
                object_link.appendChild(this.rankingExplainElement(explain));
            }
            return object_link;
        }

        // The cover link sits inside .tile. The X is a sibling of that link,
        // positioned on the cover, not inside the <a>. ContentTile never draws
        // lock/price badges; only the ERB shelf path did, and the CW branch omits them.
        object_link.style.width = 'auto';
        object_link.style.display = 'block';
        while (tile.firstChild) {
            object_link.appendChild(tile.firstChild);
        }
        tile.appendChild(object_link);
        tile.appendChild(this.dismissButton());

        let slide = document.createElement('div');
        slide.className = 'tile__slide';
        slide.appendChild(tile);
        return slide;
    }

    dismissButton() {
        let button = document.createElement('button');
        button.type = 'button';
        button.className = 'tile__dismiss';
        button.setAttribute('aria-label', 'Remove from Continue Watching');
        button.textContent = '\u00d7';

        // Belt-and-suspenders only: the home capture listener on document
        // stops the event before it reaches this target handler.
        let stop = (e) => { e.preventDefault(); e.stopPropagation(); };
        button.addEventListener('click', stop);
        return button;
    }

    rankingExplainElement(explain) {
        let wrapper = document.createElement("div");
        wrapper.className = "tile__explain";
        wrapper.style.cssText = "margin-top:4px;text-align:left;";

        let button = document.createElement("button");
        button.type = "button";
        button.className = "tile__explain__toggle";
        button.innerHTML = "&#9432; #" + (explain['position'] || '?') + " — why?";
        button.style.cssText = "background:rgba(255,255,255,.12);color:#d6d6d7;border:0;" +
            "border-radius:3px;font-size:11px;padding:2px 6px;cursor:pointer;";

        let panel = document.createElement("div");
        panel.className = "tile__explain__panel";
        panel.style.cssText = "display:none;background:#14161a;color:#d6d6d7;border:1px solid #333;" +
            "border-radius:4px;padding:8px;margin-top:4px;font-size:11px;line-height:1.45;" +
            "white-space:normal;word-break:break-word;";
        panel.innerHTML = this.rankingExplainMarkup(explain);

        // The tile itself opens the movie modal; keep both clicks separate.
        let stop = (e) => { e.preventDefault(); e.stopPropagation(); };
        button.addEventListener("click", (e) => {
            stop(e);
            panel.style.display = panel.style.display === "none" ? "block" : "none";
        });
        panel.addEventListener("click", stop);

        wrapper.appendChild(button);
        wrapper.appendChild(panel);
        return wrapper;
    }

    rankingExplainMarkup(explain) {
        let esc = (v) => String(v === undefined || v === null ? '—' : v)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

        let matched = (explain['matched_fields'] || []).map(
            (m) => esc(m['field']) + ' (' + esc((m['tokens'] || []).join(', ')) + ')'
        ).join('<br>') || '—';

        let sortValues = explain['sort_values'] || {};
        let row = (label, value) =>
            '<div><span style="opacity:.6;">' + label + ':</span> ' + value + '</div>';

        return [
            row('position', esc(explain['position'])),
            row('engine', esc(explain['engine'])),
            row('document', esc(explain['document_kind']) + ' — ' + esc(explain['title'])),
            '<hr style="border-color:#333;margin:6px 0;">',
            row('matched on', matched),
            row('_text_match', esc(explain['text_match'])),
            row('best field score', esc(explain['best_field_score']) +
                ' (weight ' + esc(explain['best_field_weight']) + ')'),
            row('fields matched', esc(explain['fields_matched'])),
            row('tokens matched', esc(explain['tokens_matched']) +
                ', dropped ' + esc(explain['num_tokens_dropped'])),
            '<hr style="border-color:#333;margin:6px 0;">',
            row('sort_by', esc(explain['sort_by'])),
            row('view_count', esc(sortValues['view_count'])),
            row('promoted_rank', esc(sortValues['promoted_rank'])),
            '<hr style="border-color:#333;margin:6px 0;">',
            row('group', esc(explain['group_key']) +
                ' (' + esc(explain['group_size']) + ' candidates)'),
            row('chosen because', esc(explain['group_winner_reason']))
        ].join('');
    }

    resolveCoverArtSrc() {
        if (this.object['cover_art.expiring_url']) {
            return this.object['cover_art.expiring_url'];
        } else if (this.object['cover_art']) {
            return this.object['cover_art'];
        } else {
            return null;
        }
    }

    resolveName() {
        if (this.object['name']) {
            return this.object['name'];
        } else if ( this.object['title'] ) {
            return this.object['title'];
        } else {
            return null;
        }
    }
}